module.exports = __webpack_public_path__ + "img/SL-M-240-260.07c5999b.svg";